<script>
  import { mapGetters, mapState } from 'vuex'
  import BreadCrumbs from '@/components/BreadCrumbs'
  import HorizontalNavigation from '@/components/HorizontalNavigation'
  import CategoriesNavigationList from '@/components/CategoriesNavigationList'
  import PaginationBase from '@/components/PaginationBase'
  import { routeSlugs } from '@/utils/routes-translations'
  import { capitalize } from '@/utils/utils'

  export default {
    components: {
      HorizontalNavigation,
      CategoriesNavigationList,
      PaginationBase,
      BreadCrumbs
    },
    async asyncData ({ store }) {
      await store.dispatch('blog/getCategories')
    },
    data () {
      return {
        pageTitle: capitalize(routeSlugs.articles.slice(1))
      }
    },
    computed: {
      ...mapState({
        config: state => state.config
      }),
      ...mapGetters({
        currentPage: 'blog/currentPage',
        totalPages: 'blog/totalPages'
      }),
      breadcrumbs () {
        return [
          { title: 'Examentips', slug: '/examentips' },
        ]
      }
    },
    methods: {
      handlePageChange (pageNum) {
        this.$refs.scrollAnchor.scrollIntoView()
        if (pageNum === 1) {
          if (this.$route.params.slug) {
            this.$router.push({ name: 'articles-category-slug___nl', params: { slug: this.$route.params.slug } })
          } else {
            this.$router.push(routeSlugs.articles)
          }
          return
        }

        const formatRouteName = (routeName, routeId) => {
          // temp fix for incorrect load of ___nl param to
          if (routeName.includes('___')) {
            const geoParamIndex = routeName.indexOf('_')
            const geoParam = routeName.slice(geoParamIndex)
            return routeName.replace(geoParam, '') + (routeId ? '' : '-page-id') + geoParam
          }
          return routeName + (routeId ? '' : '-page-id')
        }

        const routeName = formatRouteName(this.$route.name, this.$route.params.id)

        this.$router.push({ name: routeName, params: { id: pageNum } })
      }
    }
  }
</script>

<template>
  <article class="view view-articles">
    <bread-crumbs :breadcrumbs="breadcrumbs" />
    <header class="view-header pb-10 md:pb-20">
      <div class="container px-4 md:px-8">
        <div class="w-full md:w-10/12 xl:w-6/12 mx-auto md:text-center">
          <animated-title>
            <h1 class="animate text-3xl md:text-5xl pb-4 md:text-center">
              {{ pageTitle }}
            </h1>
          </animated-title>
          <p class="text-lg md:text-center">
            {{ config.fields.articlesArchiveDescription }}
          </p>
        </div>
      </div>
    </header>
    <div
      ref="scrollAnchor"
      style="position: absolute; top: -32px; left: 0; visibility: hidden;"
    />
    <div
      ref="categories-nav"
      class="container px-4 md:px-8"
    >
      <div class="w-full md:w-10/12 xl:w-6/12 mx-auto mb-6">
        <horizontal-navigation>
          <categories-navigation-list />
        </horizontal-navigation>
      </div>
    </div>
    <nuxt-child :key="Date.now()" />
    <div
      v-if="totalPages > 1"
      class="container px-4 md:px-8 mt-10"
    >
      <div class="w-full flex justify-center">
        <pagination-base
          :current-page="currentPage"
          :page-count="totalPages"
          :visible-pages="$device.isMobile ? 1 : 3"
          @update="handlePageChange"
        />
      </div>
    </div>
  </article>
</template>
